import { InstrumentDO } from "score_data";
import { IFingeringVisualizer } from "./IFingeringVisualizer";
import { RecorderFingeringVisualizer } from "./RecorderFingeringVisualizer";

export abstract class IFingeringVisualizerFactory {
	/**Creates the [IFingeringVisualizer] for the requested instrument. If
	the instrument has no matching visualizer, must return [null].*/
	abstract create(inst:InstrumentDO):IFingeringVisualizer;
}

export class FingeringVisualizerFactory implements IFingeringVisualizerFactory {
	public create(inst:InstrumentDO):IFingeringVisualizer {
		switch(inst.id){
			case 3: case 4:	case 300: case 301:	case 302: case 303:
				return new RecorderFingeringVisualizer(inst);
			default:
				return null;
		}
	}
}